import { useLocation } from 'react-router-dom';

import { useEffect } from 'react';

import { trackPageView } from '@/lib/analytics';

/**
 * Hook to track page views on route changes
 * Only tracks in production
 */
export const usePageTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
};
